import template from './force-refresh.vhtml';
import axios from 'axios';

export default {
    template,
    computedprops: {
        lastRefresh: Date,
        checker: Date,
    },
    
    // data(){
    //     return{
    //         lastRefresh: {
    //             type: Date,
    //             default: undefined
    //         },
    //         checker: {
    //             type: Date,
    //             default: undefined
    //         },
    //     }
    // },

    methods: {
        async fetchLastRefresh(){
            try {
                const response = await axios.get("/wp-json/sl/v1/force-refresh");
                var polledRefresh = response.data;
                this.checker = polledRefresh
                this.lastRefresh == undefined ? this.lastRefresh = polledRefresh : this.checker = polledRefresh
            } 
            catch (error) {
            }
        },

        pollLastRefresh() {
            this.fetchLastRefresh();

            if(this.lastRefresh > this.checker || this.lastRefresh != this.checker ){
                window.location.reload(true);
            }
        },
    },

    mounted() {
        this.pollLastRefresh()

        window.setInterval(() => {
            //Keep checking
            this.pollLastRefresh();
        }, 600000);
    },

    beforeDestroy () {
        clearInterval(this.lastRefresh, this.checker);
    },
};



// WEBPACK FOOTER //
// ./assets/_js/components/force-refresh/force-refresh.js